import React from 'react';
import { createRoot } from 'react-dom/client';
import { AdminAnalyticsPage, type AdminAnalyticsPageProps } from '../ui/admin/AdminAnalyticsPage';

export function AdminAnalyticsPageContainer(props: AdminAnalyticsPageProps) {
  return <AdminAnalyticsPage {...props} />;
}

export function mountAdminAnalyticsPage(
  container: HTMLElement,
  props: AdminAnalyticsPageProps
) {
  const root = createRoot(container);
  root.render(<AdminAnalyticsPageContainer {...props} />);
  return root;
}

export default AdminAnalyticsPageContainer;
